module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('customer-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerRevenue'),
      expression: "selectedItem === 'customerRevenue'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('customerRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('customer-type-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerTypeRevenue'),
      expression: "selectedItem === 'customerTypeRevenue'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('customerTypeRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('customer-revenue-grouped', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerRevenueGrouped'),
      expression: "selectedItem === 'customerRevenueGrouped'"
    }]
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1453ac26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1453ac26"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/customers/learning.vue
// module id = 785
// module chunks = 0